// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"120":"286b0915","127":"286b0915","155":"3c72ecab","196":"a4855678","363":"9a03c161","987":"175e051e"}[chunkId] + ".chunk.css";
};